<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">언어</td>
                <td>
                    <div>
                        <el-select v-model="langOption" @change="setFilterFunc('cid', langOption)">
                            <el-option :value="language.c_idx" :label="language.c_lang_ko"
                                       v-for="language in languageList"
                                       :key="language.c_idx"></el-option>
                        </el-select>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">카테고리</td>
                <td>
                    <div>
                        <el-input v-model="categoryName" class="long-select" placeholder="제목을 입력해주세요." @input="setData('categoryName', categoryName)"
                                  @keyup.enter.native="checkMaxLength" maxLength="10"></el-input>
                        <el-button type="primary ml10" @click="checkMaxLength">카테고리 추가</el-button>
                       <div class="mt10">카테고리는 최대 20개까지 추가 가능합니다.</div>
                    </div>
                </td>
            </tr>

            <tr>
                <td colspan="2">
                    <div>
                        <div class="drop_wrap none_drag">
                            <div class="drop_list no_maxHeight">
                                <div class="drop_list no_maxHeight"
                                     v-if="categoryList.length === 0"
                                >
                                    <div class="d_l_content no_sel">
                                        <div class="emptyDiv">카테고리가 없습니다</div>
                                    </div>
                                </div>
                                <div class="d_l_content mb10" v-for="category in categoryList" :key="`category${category.bc_idx}`" v-else>
                                    <el-input v-model="category.bc_name" class=" long-select mr10" disabled></el-input>
                                    <el-button type="info" size="mini" class=""
                                               @click="categoryDelete(category.bc_idx)">삭제
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>

</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import languageList from "@/mixins/languageList";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";

const filterConfig = {
    cid: {
        type: 'query',
        classname: 'langOption'
    },
}
export default {
    name: "BoardCategoryComponent",
    components: {},
    mixins: [alertMixins, languageList, filterMixins, listMixins],

    props: {},
    data() {
        return {
            categoryName: '',
            categoryList: [],
            disableBtn: false,
            langOption: 1,
        }
    },
    computed: {},
    created() {
        this.getCategory()
        this.getLanguage()
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
    },
    updated() {
    },
    beforeDestroy() {
    },
    methods: {
        initData() {
            this.categoryName = '';
        },

        getCategory() {
            let params = {}
            let listOptions = {
                url: this.$api.$board.getCategory,
                defaultParams: params,
            }
            this.initList('api', listOptions);

        },

        setData(key, value) {
            this[key] = value;
        },
        checkMaxLength() {
            if (this.categoryList.length >= 20) {
                this.errorAlert('더 이상 추가할 수 없습니다')
                return;
            }
            this.categoryWrite();
        },
        categoryDelete(key) {
            this.createConfirm({
                title: '',
                content: '삭제시 해당 카테고리와 카테고리내글들이 모두 삭제됩니다.<br>정말 삭제하시겠습니까?',
                confirmText: '확인',
                cancelText: '취소',
                confirm: () => {
                    this.boardDelete(key);
                }

            })
        },
        categoryWrite() {
            if (this.categoryName === '') {
                this.errorAlert('카테고리 제목을 입력해주세요');
                return;
            }
            let params = {
                c_idx: this.langOption
            }
            params.bc_name = this.categoryName
            this.$api.$board.createFaqCategory(params).then(res => res.Data.Result).then(res => {
                let type = this.returnCategoryWriteType(res.Info.type);
                if (type != true) {
                    this.errorAlert(type);
                    return false;
                }
                this.categoryName = '';
                this.createAlert({
                    title: '',
                    content: '저장되었습니다',
                    btnText: '확인',
                    hide: () => {
                        params.bc_idx = res.List;
                        this.addCategoryList(params)
                    }
                })
            })
        },
        returnCategoryWriteType(type) {
            switch (type) {
                case 300:
                    return true;
                default:
                    return '카테고리를 추가할 수 없습니다. 잠시후 다시 시도해주세요.'
            }
        },
        addCategoryList(obj) {
            this.categoryList.push(obj);
        },
        boardDelete(key) {
            let params = {}
            params.bc_idx = key;
            try {
                this.$api.$board.deleteFaqCategory(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnBoardDeleteType(res.Info.type);
                    if (type === true) {
                        this.createAlert({
                            title: '',
                            content: '카테고리가 삭제되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.unshiftCategory(key);
                            }
                        })
                        return false;
                    }
                    this.errorAlert(type);
                })
            } catch (e) {
                console.log(e)
            }
        },
        returnBoardDeleteType(type) {
            switch (type) {
                case 500:
                    return true;
                default:
                    return '카테고리 삭제에 실패하였습니다. 잠시후 다시 시도해주세요.';
            }
        },
        unshiftCategory(key) {
            let categoryIndex = this.categoryList.findIndex(cate => cate.bc_idx === key);
            if (categoryIndex > -1) {
                this.categoryList.splice(categoryIndex, 1);
            }
        },
        confirmModify(row) {
            if (row.bc_name === '') {
                this.errorAlert('카테고리 제목을 입력해주세요');
                return;
            }
            this.createConfirm({
                title: '',
                content: '해당 카테고리를 수정하시겠습니까?',
                confirmText: '확인',
                cancelText: '취소',
                confirm: () => {
                    this.categoryModify(row);
                }

            })
        },
        categoryModify(row) {
            let params = {
                bc_idx: row.bc_idx,
                bc_name: row.bc_name
            }
            this.$api.$board.updateFaqCategory(params).then(res => res.Data.Result).then(res => {
                let type = this.returnCategoryModifyType(res.Info.type);
                if (type != true) {
                    this.errorAlert(type);
                    return false;
                }
                this.createAlert({
                    title: '',
                    content: '수정되었습니다',
                    btnText: '확인',
                    hide: () => {
                        this.modifyCategoryList(row)
                    }
                })
            })
        },
        modifyCategoryList(row) {
            let categoryIndex = this.categoryList.findIndex(cate => cate.bc_idx === row.bc_idx);
            if (categoryIndex > -1) {
                this.categoryList[categoryIndex].bc_name = row.bc_name;
            }
        },
        returnCategoryModifyType(type) {
            switch (type) {
                case 400:
                    return true;
                default:
                    return '카테고리를 추가할 수 없습니다. 잠시후 다시 시도해주세요.'
            }
        },
        backEvent() {
            this.disableBtn = true
            this.$router.back()
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },

    },
    watch: {
        'List': {
            deep: true,
            handler: function (val, oldVal) {
                this.categoryList = this.List
            },
        }
    }
}
</script>

<style lang="scss">
.category_input {
    min-width: calc(100% - 120px);
}
</style>